import type { MetaGetter } from '@atlassian/jira-get-meta';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createSubscriber,
	createHook,
} from '@atlassian/react-sweet-state';
import * as actions from '../actions/index.tsx';
import type { State } from '../actions/types.tsx';
import type { Actions } from '../types.tsx';

type PropType = {
	getMeta: MetaGetter;
};

const initialState: State = {
	navigationTheme: {
		shouldShowTitle: false,
		logoUrl: '',
		usesCustomColours: false,
		backgroundColor: '',
		highlightColor: '',
	},
};

const Store = createStore<State, Actions>({
	name: 'theme',
	initialState,
	actions,
});

export const ThemeSubscriber = createSubscriber<State, Actions>(Store);

export const useTheme = createHook(Store);

export const ThemeContainer = createContainer<State, Actions, PropType>(Store, {
	onInit: actions.bootstrap,
});
